
<template>
  <div id="app">
    <!-- <div style="height:100%">
      <leftNav></leftNav>
      <router-view />
        </div>-->
    <!-- <div v-if="!$route.meta.keepAlive"> -->
    <leftNav v-if="$route.meta.keepAlive"></leftNav>
    <router-view v-loading="$store.state.loading" />
  </div>
</template>
<script>
import leftNav from "@/components/common/leftNav";
export default {
  name: "App",
  components: {
    leftNav,
  },
  created() {
    console.log(this.$route, "开始页面");
  },
};
</script>
  
<style>
@import "./assets/main.css";
.el-icon-delete {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue